import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { OBJLoader } from "three/examples/jsm/loaders/OBJLoader";
import { storage } from "./Firebase";
import * as AnimationLib from "./AnimationLib";
import * as THREE from "three";
import Toast from "./Toast";
import { GreenFabric, ConcreteMuddy } from "./TextureLib";
import { CinquefoilKnot } from "./CurvesExtra";
import { Vector2, Vector3 } from "three";

const gltfLoader = new GLTFLoader();
const objLoader = new OBJLoader();

const loadByName = async (
  scene: THREE.Scene,
  name: string,
  storagePath: string,
  loadAnimations: boolean
): Promise<void> => {
  return await storage
    .ref(storagePath)
    .getDownloadURL()
    .then((value: string) => {
      const useOBJLoader = storagePath.endsWith("obj");
      const loader: GLTFLoader | OBJLoader = useOBJLoader
        ? objLoader
        : gltfLoader;
      loader.load(
        // resource URL
        value,
        // called when the resource is loaded
        (gltf) => {
          if (useOBJLoader) {
            gltf.name = name;
            scene.add(gltf);
          } else {
            if (loadAnimations && gltf.animations.length > 0) {
              const mixer = new THREE.AnimationMixer(gltf.scene);
              scene.userData[`mixer-${name}`] = mixer;
              gltf.animations.forEach((clip, index, arr) => {
                scene.userData[`mixer-${name}-clip-${index}`] = clip;
                mixer.clipAction(clip).play();
              });
            }
            gltf.scene.name = name;
            scene.add(gltf.scene);
            gltf.scene.visible = false;
          }

          Toast(`Download: ${name}`);
        },
        // called while loading is progressing
        (xhr) => {
          // console.log(`${name}: ` + (xhr.loaded / xhr.total) * 100 + "% loaded")
        },
        // called when loading has errors
        (error) => {
          // console.log(`An error happened when loading ${name}`)
        }
      );
    });
};
let AnimationMaps: { [key: string]: AnimationLib.AnimationFunction } = {};

const StoneFruit = async (scene: THREE.Scene): Promise<void> => {
  const name = "StoneFruit";
  const geometry = new THREE.SphereGeometry(1, 100, 100);
  const textureItem = await GreenFabric();
  const mesh = new THREE.Mesh(
    geometry,
    new THREE.MeshStandardMaterial({
      roughnessMap: textureItem.roughnessMap,
      color: "grey",
    })
  );
  mesh.name = name;
  const animation = AnimationLib.SineWaveBufferGeometry(mesh);
  AnimationMaps[name] = animation;
  scene.add(mesh);
  Toast(`Constructing: ${name}`);
};

const RollerCoaster = async (scene: THREE.Scene): Promise<void> => {
  const name = "RollerCoaster";
  const curve = new CinquefoilKnot();
  const geometry = new THREE.TubeBufferGeometry(curve, 200, 2, 2, true);
  const material = new THREE.MeshBasicMaterial({
    color: "red",
    wireframe: true,
  });
  const mesh = new THREE.Mesh(geometry, material);
  mesh.name = name;
  const animation = AnimationLib.CameraFollowTube(mesh);
  AnimationMaps[name] = animation;
  scene.add(mesh);
  Toast(`Constructing: ${name}`);
};

const Majapahit = async (scene: THREE.Scene): Promise<void> => {
  const name = "Majapahit";
  const geometry = new THREE.PlaneGeometry(10, 10, 10, 10);
  const material = new THREE.MeshBasicMaterial({
    color: "red",
    wireframe: true
  });
  const mesh = new THREE.Mesh(geometry, material);
  mesh.geometry.attributes.uv2 = mesh.geometry.attributes.uv
  mesh.rotateOnAxis(new Vector3(1, 0, 0), Math.PI / 2);
  mesh.name = name;
  mesh.position.setY(-1);
  const animation = AnimationLib.CameraFollowControl(mesh);
  AnimationMaps[name] = animation;
  scene.add(mesh);
  Toast(`Constructing: ${name}`);
};



export { StoneFruit, RollerCoaster, Majapahit, AnimationMaps };
